import Vue from "vue";
import {Component} from "vue-property-decorator";
import "./loginCard.styl";
import {UserStatus} from "../../../models/userStatus";
import {Routes} from "../../../router";
import {eventBus, signalNames} from "../../../bus";
import {StoreManager} from "../../../store";
import {session} from "../../../stores/session";
const template = require("./loginCard.vue");

@Component({
  template: template
})
export class LoginCardComponent extends Vue {

  isLogging: boolean = false;

  tabs: { hasName: boolean, name: string, email: string, password: string, description: string }[] = [
    {
      name: "",
      hasName: false,
      email: "",
      password: "",
      description: "Login",
    },
    // {
    //   name: "",
    //   hasName: true,
    //   email: "",
    //   password: "",
    //   description: "SignUp",
    // }
  ];

  active = null;

  created(): void {
    this.$store.watch(
      () => this.$store.state.session.status,
      () => {
        this.isLogging = this.$store.state.session.status === UserStatus.Logging;
        switch (this.$store.state.session.status) {
          case UserStatus.LoggedIn:
            this.$router.push({name: Routes.adminHome.name});
            break;
          case UserStatus.NotLoggedIn:
        }
      }
    );
  }

  handleLoginClick(): Promise<any> {
    return session.dispatchManualLogin(this.$store, {email: this.tabs[0].email, password: this.tabs[0].password})
      .catch(error => {
        session.commitCleanCurrentUser(this.$store);
        eventBus.$emit(signalNames.showError, "Utente o password non corretti!");
      });
  }
  handleSignUpClick(): Promise<any> {
    return session.dispatchManualSignUp(this.$store, {email: this.tabs[1].email, password: this.tabs[1].password, name: this.tabs[1].name})
      .catch(error => {
        session.commitCleanCurrentUser(this.$store);
        eventBus.$emit(signalNames.showError);
      });
  }
  handleResetClick() {
    this.tabs.forEach(tab => { tab.email = ""; tab.password = ""; tab.name = ""; });
  }
  backClick () {
    this.$router.go(-1);
  }

}

Vue.component("cmLoginCard", LoginCardComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/plain/loginCard/loginCard.ts